import { ReactNode } from 'react'

import { clsx } from 'clsx'

import { Text } from '@tribeplatform/react-ui-kit/Text'

export const Section = ({
  children,
  title,
}: {
  children: ReactNode
  title: ReactNode
}) => {
  return (
    <div className={clsx('flex flex-col gap-y-4')}>
      <Text className="text-content-muted">{title}</Text>
      {children}
    </div>
  )
}
